<template>
    <div>
        <Header v-if="!stepConfig" :title="title" :subtitle="description" />
        <div v-if="stepConfig" class="d-flex flex-column justify-between h-100 min-h-[500px]">
            <div class="d-flex flex-column gap-2">
                <button
                    @click="$emit('update-step', 1)"
                    class="ppv2-flex ppv2-items-center ppv2-gap-2 ppv2-px-2 ppv2-py-1.5 ppv2-rounded-xl ppv2-border-none ppv2-bg-transparent ppv2-text-[#6a6588] poppinsBold ppv2-text-[15px] ppv2-cursor-pointer -ppv2-ml-2 ppv2-mb-4"
                >
                    <ArrowLeft /> {{ $t('widgetIntegration.backToWidgets') }}
                </button>

                <Header v-if="stepConfig" :title="title" :subtitle="description" />

                <div class="ppv2-flex ppv2-flex-col ppv2-gap-[18px]">
                    <template v-if="stepConfig.type === 'entity-with-toggle'">
                        <div class="ppv2-flex ppv2-flex-col ppv2-gap-[18px]">
                            <CookieManagementToggle
                                :value="value"
                                :widget-id="selectedWidget.id"
                                @input="$emit('input', $event)"
                            />
                        </div>
                        <div
                            v-if="!value"
                            class="ppv2-flex ppv2-gap-[11px] ppv2-items-start bg-purple ppv2-bg-opacity-[13%] ppv2-rounded-[13px] ppv2-py-[14px] ppv2-px-[16px]"
                        >
                            <span class="ppv2-text-[13.5px] ppv2-text-black ppv2-opacity-80 ppv2-leading-[1.5]">
                                <Eye /> {{ $t('widgetIntegration.fullListInfo') }}
                            </span>
                        </div>
                        <div class="ppv2-flex ppv2-flex-col ppv2-gap-[18px]">
                            <WidgetEntitySelector
                                v-if="value"
                                :items="stepConfig.items"
                                :show-actions="stepConfig.showActions"
                                :edit-path="stepConfig.editPath"
                                :create-path="stepConfig.createPath"
                                :edit-label="stepConfig.editLabel"
                                :create-label="stepConfig.createLabel"
                                @selected="$emit(stepConfig.event, $event)"
                            />
                        </div>
                    </template>

                    <template v-if="stepConfig.type === 'categories'">
                        <div class="ppv2-flex ppv2-flex-col ppv2-gap-[18px]">
                            <WidgetEntitySelector
                                :items="stepConfig.items"
                                :show-actions="stepConfig.showActions"
                                :select-label="stepConfig.selectLabel"
                                @selected="$emit(stepConfig.event, $event)"
                            />
                        </div>
                    </template>

                    <template v-if="stepConfig.type === 'info'">
                        <div
                            class="ppv2-flex ppv2-gap-[11px] ppv2-items-start bg-purple ppv2-bg-opacity-[13%] ppv2-rounded-[13px] ppv2-py-[14px] ppv2-px-[16px]"
                        >
                            <span class="ppv2-text-[13.5px] ppv2-text-black ppv2-opacity-80 ppv2-leading-[1.5]">
                                <Check /> {{ stepConfig.message }}
                            </span>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Eye, ArrowLeft, Check } from 'lucide-vue'
import CookieManagementToggle from './CookieManagementToggle.vue'
import WidgetEntitySelector from './WidgetEntitySelector.vue'
import Header from '../../Shared/Header.vue'
export default {
    name: 'WidgetHeader',
    components: {
        Eye,
        ArrowLeft,
        CookieManagementToggle,
        Check,
        WidgetEntitySelector,
        Header,
    },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            default: '',
        },
        titleColor: {
            type: String,
            default: '#131c31',
        },
        titleSize: {
            type: String,
            default: '2rem',
        },
        maxWidth: {
            type: String,
            default: '500px',
        },
        selectedWidget: {
            type: Object,
            default: () => null,
        },
        widgetId: {
            type: String,
            default: 'restaurant',
        },
        stepConfig: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {}
    },
}
</script>
